export default __webpack_public_path__ + "static/media/previous_group.bfc74cbe.svg";